<template>
  <NuxtLink :to="localePath({ name: 'index' })" class="logo">
    <LogoIcon class="logo-svg" />
  </NuxtLink>
</template>

<script lang="ts" setup>
import LogoIcon from '@/assets/icons/logo.svg'

const localePath = useLocalePath()
</script>

<style lang="scss" scoped>
.logo {
  @include focus-visible;
  display: block;
  cursor: pointer;
  transition: opacity $transition;

  &:hover {
    opacity: 0.75;
  }
}

.logo-svg {
  width: 141px;
  height: auto;
}
</style>
